import { useMemo } from "react";
import { VerticalDistributionComponent } from "../shared/components/VerticalDistributionComponent";
import { TOTAL_QUESTIONS } from "../shared/model/GameUtils";

export function PrecisionStatsComponent({ data }) {
  const totalCorrectShare = useMemo(() => {
    const totalAnswered = data.map(g => g.stats.answeredQuestions).reduce((a,b) => a+b, 0)
    const correctlyAnswered = data.map(g => g.answers.filter(a => a === "RIGHT").length).reduce((a,b) => a+b, 0)
    return (correctlyAnswered / totalAnswered).toPrecision(4) * 100;
  }, [data])

  const correctSharePerQuestion = useMemo(() => {
    return [...Array(TOTAL_QUESTIONS).keys()]
      .map(i => data.map(g => g.answers[i]))
      .map((x) => {
        const totalAnsweredAtI = x.length
        const correctlyAnsweredAtI = x.filter(a => a === "RIGHT").length
        return (correctlyAnsweredAtI / totalAnsweredAtI).toPrecision(4) * 100;
      })
  }, [data])

  return (
    <section className="vertical-container justify">
      <span className="small bottom-margin">Als <i>Präzision</i> ist der Anteil <i>richtig beantworteter Fragen</i> definiert.</span>

      <div className="vertical-container top-margin gap-1">
        <span>
          In allen Spielen hast du
          <span className="glow primary horizontal-padding"> {totalCorrectShare}% </span>
          der Fragen richtig beantwortet.
        </span>

        <div>
          <span className="">Präzision</span> pro Frage:
          <VerticalDistributionComponent values={correctSharePerQuestion} unit="%" />
        </div>
      </div>
    </section>
  );
}
